
define('text!presentation/shell/views/index.html',[],function () { return '<div class="content">\n\n</div>\n';});

